import { Styles } from '@orcar/common-d2c';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useSeo } from '@/hooks/useSeo';
import { EVENTS } from './eventData';

/**
 * 이벤트 목록. 썸네일 카드 그리드 → 클릭 시 상세(/event/:id).
 * 상세와 함께 SEO(제주렌트카 키워드)를 노린다.
 */
const EventPage = () => {
  useSeo({
    title: '이벤트 · 혜택 | 제주로렌트카',
    description:
      '제주로렌트카의 다양한 이벤트와 혜택을 확인하세요. 재방문 무료 커피 등 제주공항 렌트카 예약 시 받을 수 있는 제주도 렌트카 혜택을 모았습니다.',
  });

  return (
    <Center>
      <Inner>
        <Header>
          <Title>이벤트</Title>
          <Subtitle>제주로렌트카의 다양한 이벤트와 혜택을 확인하세요.</Subtitle>
        </Header>

        <Grid>
          {EVENTS.map((event) => (
            <Card key={event.id} to={`/event/${event.id}`}>
              <Thumb>
                <img src={event.thumbnail} alt={event.title} loading='lazy' />
              </Thumb>
              <CardBody>
                <CardTitle>{event.title}</CardTitle>
                <CardSummary>{event.summary}</CardSummary>
                <CardPeriod>{event.period}</CardPeriod>
              </CardBody>
            </Card>
          ))}
        </Grid>
      </Inner>
    </Center>
  );
};

export default EventPage;

const Center = styled.div`
  display: flex;
  justify-content: center;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1120px;
  padding: 32px 20px 72px;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 36px;
`;

const Title = styled.h1`
  ${Styles.FONT.H2};
  color: ${Styles.COLOR.GREY_01};
  margin: 0 0 10px;
`;

const Subtitle = styled.p`
  ${Styles.FONT.B1};
  color: ${Styles.COLOR.GREY_03};
  margin: 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  text-decoration: none;
  color: inherit;

  &:hover img {
    transform: scale(1.03);
  }
`;

const Thumb = styled.div`
  width: 100%;
  aspect-ratio: 3 / 2;
  border-radius: 14px;
  overflow: hidden;
  background: ${Styles.COLOR.GREY_BG};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const CardTitle = styled.h2`
  ${Styles.FONT.H4};
  color: ${Styles.COLOR.GREY_01};
  margin: 0;
`;

const CardSummary = styled.p`
  ${Styles.FONT.B2};
  color: ${Styles.COLOR.GREY_03};
  margin: 0;
`;

const CardPeriod = styled.span`
  ${Styles.FONT.B3};
  color: ${Styles.COLOR.GREY_04};
  margin-top: 2px;
`;
